import { useSyncExternalStore } from 'react';
import { useUserStore } from '../../stores/userStore';

// Revision also records transient sign-out/sign-in within one React batch.
// Credentials stay in memory and are never included in keys or diagnostics.
let owner;
let revision = 0;
const listeners = new Set();
const snapshot = () => {
  const state = useUserStore.getState();
  const next = [
    state.user?.id,
    state.isLogin,
    state.isAdmin,
    localStorage.getItem('POSTPOP_AUTH_TOKEN'),
  ];
  if (!owner || next.some((value, index) => value !== owner[index])) {
    owner = next;
    revision += 1;
  }
  return revision;
};
useUserStore.subscribe(() => {
  snapshot();
  listeners.forEach((listener) => listener());
});
const subscribe = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};
export const isBadgeSessionCurrent = (session) => snapshot() === session;
export default function useBadgeSession() {
  return useSyncExternalStore(subscribe, snapshot, snapshot);
}
